import { breakpoints } from "theme/breakpoints";
import { MediaQueryConfig } from "utils/styles";

export const animationMediaQueryConfig: MediaQueryConfig = {
  minWidth: breakpoints.lg,
  minAspectRatio: "16/10",
  maxAspectRatio: "24/10",
};
